var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-card',[_c('mdb-card-body',[_c('mdb-card-title',{staticClass:"mb-5"},[(_vm.icon)?_c('mdb-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.title))],1),_c('mdb-card-text',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }